import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {ShareNameDeviceModel} from '../../../../models/ShareNameDeviceModel';
import {SharenameDeviceAnagrafService} from '../../../general-services/service-sharename-device-anagraf/sharename-device-anagraf.service';
import {LoaderService} from '../../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-edit-sharename-device-anagraf',
  templateUrl: './edit-sharename-device-anagraf.component.html',
  styleUrls: ['./edit-sharename-device-anagraf.component.scss']
})
export class EditSharenameDeviceAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  shareNameDevice: ShareNameDeviceModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  parameterSubscribe: Subscription;
  saveSubscribe: Subscription;
  submitted = false;

  id: number;
  shareNameCod: string;
  description: string;
  shareNameJson: any;

  constructor(private route: ActivatedRoute, private router: Router,
              private shareNameService: SharenameDeviceAnagrafService, private _activatedRoute: ActivatedRoute,
              private loaderService: LoaderService) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.shareNameJson = params['row'];
      });

    this.shareNameDevice = new ShareNameDeviceModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });
    this.shareNameDevice = JSON.parse(this.shareNameJson) as ShareNameDeviceModel;

    this.formValidator.patchValue({
      cod: this.shareNameDevice ? this.shareNameDevice.cod : ''
    });

    this.formValidator.patchValue({
      description: this.shareNameDevice ? this.shareNameDevice.description : ''
    });

    _activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      this.shareNameCod = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
   // this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SHARENAME_DEVICE_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.shareNameDevice.cod = this.formValidator.controls['cod'].value;
      this.shareNameDevice.description = this.formValidator.controls['description'].value;
      this.saveSubscribe = this.shareNameService.update(this.shareNameService.baseUrl, this.shareNameDevice).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, ShareName Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('ShareName was edited with success', 'Success');
      //      this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SHARENAME_DEVICE_ANAGRF]);
          }
        }, error => {
          this.loaderService.display(false);
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.formValidator.controls; }

}
